export var skipToken = Symbol.for("apollo.skipToken");
